(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-comparer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function createCarousel(carousel, onCenterChange) {
      const viewport = carousel.querySelector('[data-cc-viewport]');
      const track = carousel.querySelector('[data-cc-track]');
      if (!viewport || !track) return null;

      const originals = Array.from(track.children);
      const originalsCount = originals.length;
      if (!originalsCount) return null;

      let allItems = originals;
      let currentIndex = 0;
      let segments = 1;
      let built = false;
      let pointerId = null;
      let dragStartX = 0;
      let dragStartTime = 0;
      let dragBaseOffset = 0;
      let dragMoved = false;
      let downItem = null;
      let suppressNextClick = false;

      // Cloning needs real widths, which only exist once the panel is visible,
      // so the whole build is deferred to the first activation. The track is
      // positioned with `transform`, not native scroll, so there's no fling
      // distance to absorb — but a single drag gesture can still span close
      // to a full viewport width, so enough segments are built on each side
      // to comfortably outlast that (matters most with few real cards, where
      // one segment can be much narrower than the viewport).
      function build() {
        built = true;

        if (originalsCount === 1) {
          track.classList.add('is-single');
          return;
        }

        const originalsWidth = Math.max(track.scrollWidth, 1);
        segments = Math.max(1, Math.ceil(viewport.clientWidth / originalsWidth));

        for (let i = 0; i < segments; i += 1) {
          originals.forEach((el) => {
            const clone = el.cloneNode(true);
            clone.classList.add('is-clone');
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          });
        }

        for (let i = 0; i < segments; i += 1) {
          originals
            .slice()
            .reverse()
            .forEach((el) => {
              const clone = el.cloneNode(true);
              clone.classList.add('is-clone');
              clone.setAttribute('aria-hidden', 'true');
              track.insertBefore(clone, track.firstChild);
            });
        }

        allItems = Array.from(track.children);
        currentIndex = segments * originalsCount;
      }

      // offsetLeft/offsetWidth reflect the track's own static flex layout —
      // unaffected by the transform used to position it — so they're a
      // direct, reliable read of where an item actually sits.
      function offsetForIndex(index) {
        const item = allItems[index];
        if (!item) return 0;
        return -(item.offsetLeft + item.offsetWidth / 2 - viewport.clientWidth / 2);
      }

      // The loop-settle jump swaps which physical element is "centered" for
      // a pixel-identical duplicate in one instant frame — the swapped-in
      // duplicate was, until that instant, off-screen and scaled down as a
      // far item. Left alone, its own scale transition would still animate
      // that catch-up visibly (pops small, grows back to full size) even
      // though the jump itself is invisible. Freezing each card's own
      // transition for that one frame makes the class swap land instantly,
      // matching the equally-instant position jump.
      function updateClasses(instant) {
        if (instant) {
          allItems.forEach((item) => {
            const card = item.querySelector('.collection-comparer__item-card');
            if (card) card.style.transition = 'none';
          });
        }

        allItems.forEach((item, index) => {
          const distance = Math.abs(index - currentIndex);
          item.classList.toggle('is-centered', distance === 0);
          item.classList.toggle('is-near', distance === 1);
          item.classList.toggle('is-far', distance > 1);
        });

        if (instant) {
          void track.offsetWidth;
          requestAnimationFrame(() => {
            allItems.forEach((item) => {
              const card = item.querySelector('.collection-comparer__item-card');
              if (card) card.style.transition = '';
            });
          });
        }

        const centered = allItems[currentIndex];
        if (centered) onCenterChange(centered.dataset);
      }

      function moveTo(index, animate) {
        currentIndex = Math.max(0, Math.min(allItems.length - 1, index));
        track.style.transition = animate ? 'transform 300ms ease' : 'none';
        track.style.transform = `translateX(${offsetForIndex(currentIndex)}px)`;
        updateClasses(!animate);
      }

      // Once an animated move (or a drag release) lands outside the middle
      // segment, fold it back in — instantly, with no transition. Every
      // segment is built the same way, so shifting by a whole number of
      // segments always lands on a pixel-for-pixel identical position and
      // the jump reads as if nothing happened. The while loops (rather than
      // a single shift) mean this still fully recentres even if a gesture
      // somehow crossed more than one segment at once.
      function settleLoop() {
        if (originalsCount <= 1) return;
        const canonicalStart = segments * originalsCount;
        let index = currentIndex;
        while (index < canonicalStart) index += originalsCount;
        while (index >= canonicalStart + originalsCount) index -= originalsCount;
        if (index !== currentIndex) moveTo(index, false);
      }

      track.addEventListener('transitionend', (event) => {
        if (event.target === track && event.propertyName === 'transform') settleLoop();
      });

      function nearestIndexForOffset(offset) {
        const target = viewport.clientWidth / 2;
        let best = currentIndex;
        let bestDistance = Infinity;
        allItems.forEach((item, index) => {
          const center = item.offsetLeft + item.offsetWidth / 2 + offset;
          const distance = Math.abs(center - target);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = index;
          }
        });
        return best;
      }

      if (originalsCount > 1) {
        // Stops the browser's native image-ghost drag without touching
        // pointerdown's default action — calling preventDefault() there
        // instead suppresses the compatibility click event entirely, which
        // is exactly what broke clicking.
        track.addEventListener('dragstart', (event) => event.preventDefault());

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartTime = event.timeStamp;
          dragBaseOffset = offsetForIndex(currentIndex);
          dragMoved = false;
          // Resolved now, not from the later 'click' event — once the
          // pointer is captured below, some browsers retarget the
          // compatibility click event to the capturing element (track)
          // itself rather than the card actually under the pointer, which
          // silently broke tap-to-select.
          downItem = event.target.closest('.collection-comparer__item');
          track.style.transition = 'none';
          track.setPointerCapture(pointerId);
        });

        track.addEventListener('pointermove', (event) => {
          if (pointerId === null || event.pointerId !== pointerId) return;
          const delta = event.clientX - dragStartX;
          // A few px of incidental movement between press and release is
          // normal for an ordinary click/tap — too low a threshold here
          // misclassifies plain clicks as drags.
          if (Math.abs(delta) > 10) dragMoved = true;
          track.style.transform = `translateX(${dragBaseOffset + delta}px)`;
        });

        const endDrag = (event) => {
          if (pointerId === null || event.pointerId !== pointerId) return;
          track.releasePointerCapture(pointerId);
          pointerId = null;

          if (!dragMoved) {
            // A plain tap: select the card that was actually pressed, unless
            // it's already the centered one — then leave it to the native
            // click/link below.
            if (downItem && !downItem.classList.contains('is-centered')) {
              const index = allItems.indexOf(downItem);
              if (index !== -1) {
                suppressNextClick = true;
                moveTo(index, true);
              }
            } else {
              moveTo(currentIndex, false);
            }
            return;
          }

          const delta = event.clientX - dragStartX;
          const elapsed = event.timeStamp - dragStartTime;
          let target = nearestIndexForOffset(dragBaseOffset + delta);

          // A quick short flick can land back on the same nearest item by
          // pure distance even though the user clearly meant to advance —
          // nudge it one slot in the drag direction, same idea as Slick's
          // touchThreshold.
          if (target === currentIndex && elapsed < 300 && Math.abs(delta) > 30) {
            target = currentIndex + (delta < 0 ? 1 : -1);
          }

          suppressNextClick = true;
          moveTo(target, true);
        };

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        // A card off to the side is a drag/tap target, not a link — the
        // actual selection already happened above (from the pointerdown
        // target, not this event's), so all this does is stop the centered
        // card's own link-follow from also firing after we've just acted.
        track.addEventListener('click', (event) => {
          if (suppressNextClick) {
            suppressNextClick = false;
            event.preventDefault();
          }
        });

        // Native scroll used to pick up trackpad/mouse-wheel horizontal
        // scrolling for free; the transform-based track doesn't, so it's
        // wired up explicitly here — one tick of meaningful horizontal
        // input moves one card, debounced so a continuous trackpad swipe
        // doesn't fire dozens of moves at once.
        let wheelLocked = false;
        track.addEventListener(
          'wheel',
          (event) => {
            const delta =
              Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.shiftKey ? event.deltaY : 0;
            if (Math.abs(delta) < 10) return;

            event.preventDefault();
            if (wheelLocked) return;

            wheelLocked = true;
            moveTo(currentIndex + (delta > 0 ? 1 : -1), true);
            setTimeout(() => {
              wheelLocked = false;
            }, 300);
          },
          { passive: false }
        );
      }

      return {
        activate() {
          carousel.classList.add('is-active');
          requestAnimationFrame(() => {
            if (!built) build();
            moveTo(currentIndex, false);
          });
        },
        deactivate() {
          carousel.classList.remove('is-active');
        },
        refresh() {
          if (!built) return;
          moveTo(currentIndex, false);
        },
      };
    }

    function initCollectionComparer(section) {
      if (!section || section.dataset.ccInitialized === 'true') return;

      const tabs = Array.from(section.querySelectorAll('[data-cc-tab]'));
      const carousels = Array.from(section.querySelectorAll('[data-cc-carousel]'));
      const titleNode = section.querySelector('[data-cc-title]');
      const descriptionNode = section.querySelector('[data-cc-description]');
      const linkNode = section.querySelector('[data-cc-link]');

      if (!tabs.length || !carousels.length || !titleNode || !descriptionNode || !linkNode) return;
      section.dataset.ccInitialized = 'true';

      function renderMeta(data) {
        titleNode.textContent = data.productTitle || '';
        descriptionNode.textContent = data.productDescription || '';
        linkNode.href = data.productUrl || '#';
      }

      const states = carousels.map((carousel) => createCarousel(carousel, renderMeta));
      let activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        states.forEach((state, i) => {
          if (!state) return;
          if (i === index) state.activate();
          else state.deactivate();
        });
      }

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => setActive(i));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = (i + step + tabs.length) % tabs.length;
          setActive(next);
          tabs[next].focus();
        });
      });

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const activeState = states[activeIndex];
          if (activeState) activeState.refresh();
        }, 150);
      });

      setActive(0);
    }

    function initAll() {
      document.querySelectorAll('[data-cc-section]').forEach(initCollectionComparer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const section =
          event.target && event.target.matches('[data-cc-section]')
            ? event.target
            : event.target && event.target.querySelector('[data-cc-section]');

        if (section) {
          initCollectionComparer(section);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function initFooterAccordion(footer) {
      footer.querySelectorAll('.footer__col-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isMobile = window.matchMedia('(max-width: 767px)').matches;
          if (!isMobile) return;
          var body = btn.closest('.footer__column').querySelector('.footer__col-body');
          if (!body) return;
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          body.classList.toggle('is-open', !isOpen);
        });
      });
    }

    document.querySelectorAll('footer').forEach(initFooterAccordion);

    document.addEventListener('shopify:section:load', function (e) {
      var footer = e.target.querySelector('footer');
      if (footer) initFooterAccordion(footer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Desktop submenus ── */
  document.querySelectorAll('.header__menu-item.has-submenu').forEach(function (item) {
    var btn = item.querySelector('.header__menu-btn');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.header__menu-item.has-submenu.open').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.header__menu-item.has-submenu.open').forEach(function (i) {
      i.classList.remove('open');
    });
    var helpMenu = document.querySelector('.header__help-menu.open');
    if (helpMenu) {
      helpMenu.classList.remove('open');
      var helpBtn = helpMenu.querySelector('.header__help-btn');
      if (helpBtn) helpBtn.setAttribute('aria-expanded', 'false');
    }
  });

  var helpMenu = document.querySelector('.header__help-menu');
  if (helpMenu) {
    var helpBtn = helpMenu.querySelector('.header__help-btn');
    if (helpBtn) {
      helpBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = helpMenu.classList.contains('open');
        document.querySelectorAll('.header__menu-item.has-submenu.open').forEach(function (i) {
          i.classList.remove('open');
        });
        helpMenu.classList.toggle('open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  }

  /* ── Mobile overlay ── */
  var overlay = document.getElementById('mobile-overlay');
  var toggleBtn = document.getElementById('mobile-menu-toggle');
  var closeBtn = document.getElementById('mobile-menu-close');
  var backdrop = document.getElementById('mobile-overlay-backdrop');

  function openOverlay() {
    overlay.classList.add('mobile-overlay--open');
    overlay.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay() {
    overlay.classList.remove('mobile-overlay--open');
    overlay.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openOverlay);
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (backdrop) backdrop.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('mobile-overlay--open')) {
      closeOverlay();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // One dataset key per spec metafield; matches the data-* attributes the
    // option snippet emits and the data-mc-cell values in the table rows.
    var SPEC_FIELDS = ['technology', 'firmness', 'height', 'extra'];

    // The markup only ships an <img> when the initial product has one, so a
    // column that starts on an imageless product still gets a node to write
    // into the moment the picker moves to a product that has an image.
    function ensureMainImage(imageCell) {
      const existing = imageCell.querySelector('[data-mc-main-image]');
      if (existing) return existing;

      const media = imageCell.querySelector('.product-comparison__media');
      if (!media) return null;

      const img = document.createElement('img');
      img.className = 'product-comparison__main-image';
      img.setAttribute('data-mc-main-image', '');
      img.loading = 'lazy';
      media.appendChild(img);
      return img;
    }

    // A spec row stays in the DOM so the pickers have somewhere to write,
    // but hides while no column has a value for it.
    function updateSpecRows(table) {
      table.querySelectorAll('[data-mc-spec-row]').forEach((row) => {
        // Only the value spans count — the inline labels always hold text,
        // even while hidden.
        const hasValue = Array.from(row.querySelectorAll('[data-mc-value]')).some(
          (value) => value.textContent.trim() !== ''
        );
        row.hidden = !hasValue;
      });
    }

    function syncColumnWithSelection(table, col, select, debug) {
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const cellFor = (field) => table.querySelector(`[data-mc-cell="${field}"][data-mc-col="${col}"]`);

      if (debug) {
        console.log('[Mattress Comparison]', option.value, option.dataset);
      }

      const imageCell = cellFor('image');
      const imageSrc = option.dataset.imageSrc || '';
      if (imageCell) {
        if (imageSrc) {
          const mainImage = ensureMainImage(imageCell);
          if (mainImage) {
            // The markup ships a srcset, and a srcset always outranks src — so
            // assigning src alone left the original product's image on screen.
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = imageSrc;
            mainImage.alt = option.dataset.imageAlt || option.textContent.trim();
            mainImage.removeAttribute('hidden');
          }
        } else {
          const mainImage = imageCell.querySelector('[data-mc-main-image]');
          if (mainImage) mainImage.setAttribute('hidden', 'hidden');
        }
      }

      const priceCell = cellFor('price');
      const priceValue = priceCell && priceCell.querySelector('[data-mc-price-value]');
      if (priceValue) {
        priceValue.textContent = option.dataset.price || '';
      }

      // Spec cells exist only on the full table; the compact pair skips them.
      // Written unconditionally: a product with no metafields must clear the
      // previous selection's values rather than leave them attributed to it.
      SPEC_FIELDS.forEach((field) => {
        const cell = cellFor(field);
        if (!cell) return;
        const text = option.dataset[field] || '';
        const value = cell.querySelector('[data-mc-value]');
        if (value) value.textContent = text;
        // The inline label hides with its value so an empty cell never shows
        // a dangling "Label:".
        const label = cell.querySelector('[data-mc-label]');
        if (label) label.hidden = text === '';
      });

      const ctaCell = cellFor('cta');
      const cta = ctaCell && ctaCell.querySelector('[data-mc-cta]');
      if (cta && option.dataset.url) {
        cta.setAttribute('href', option.dataset.url);
      }

      updateSpecRows(table);
    }

    function initMattressComparison(section) {
      const debug = section.hasAttribute('data-mc-debug');
      section.querySelectorAll('[data-mc-table]').forEach((table) => {
        table.querySelectorAll('[data-mc-select]').forEach((select) => {
          const holder = select.closest('[data-mc-col]');
          if (!holder) return;
          const col = holder.getAttribute('data-mc-col');

          // Runs on load too: browsers restore a <select>'s previous value on
          // reload, which would otherwise leave the column showing another
          // product.
          syncColumnWithSelection(table, col, select, debug);
          select.addEventListener('change', () => syncColumnWithSelection(table, col, select, debug));
        });
      });
    }

    document.querySelectorAll('[id^="product-comparison-"]').forEach(initMattressComparison);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section && section.querySelector('[data-mc-table]')) {
        initMattressComparison(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
